<template>
  <div class="login">
    <h2 class="pag"><i class="fa fa-car"></i> Miranda ERP</h2>
    <br />
    <h2>
      <a class="pag" href="https://www.repuestosmiranda.cl" target="_blank"
        >Repuestos Miranda SPA</a
      >
    </h2>
    <br />
    <br />
    <!-- ALERT -->
    <vuestic-alert v-if="success" type="success" :withCloseBtn="true">
      {{ success }}
    </vuestic-alert>
    <vuestic-alert v-if="serverError" type="danger" :withCloseBtn="true">
      {{ serverError }}
    </vuestic-alert>
    <!-- SPINNER -->
    <atom-spinner v-if="loading" class="spinner" />
    <form
      @submit.prevent="login"
      method="post"
      action="/auth/login"
      name="login"
    >
      <div class="form-group">
        <div class="input-group">
          <input
            type="text"
            id="usuario"
            v-model="username"
            required="required"
          />
          <label class="control-label" for="usuario">Usuario</label>
          <i class="bar"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input
            autocomplete="off"
            v-model="password"
            type="password"
            id="password"
            required="required"
          />
          <label class="control-label" for="password">
            Contraseña
          </label>
          <i class="bar" />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <select
            v-model="modelSucursal"
            name="sucursal"
            id="sucursal"
            required="required"
          >
            <option value="">Seleccione...</option>
            <option
              v-for="sucursal in sucursales"
              v-if="sucursal.estado === 'activo'"
              :value="sucursal"
            >
              {{ sucursal.nombre | upperCase }}
            </option>
          </select>
          <i class="bar"></i>
        </div>
      </div>
      <div class="d-flex align--center justify--space-between">
        <button class="btn btn-info" type="submit">
          Ingresar
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import Spinners from "../../ui/spinners/Spinners";
import axios from "axios";
import AtomSpinner from "epic-spinners/src/components/lib/AtomSpinner";
import VuesticSimpleSelect from "../../../vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect";
import Autocomplete from "../../compra/component/Input/autocomplete";
import { URL_SERVER, URL_SUCURSAL } from "../../../api/config";
import InputComp from "../../Componentes_Globales/Input/inputComp";

export default {
  name: "login",
  components: {
    InputComp,
    Autocomplete,
    VuesticSimpleSelect,
    AtomSpinner,
    Spinners,
  },
  data() {
    return {
      username: "",
      password: "",
      serverError: "",
      loading: false,
      modelSucursal: "",
      success: "",
      userLog: "",
    };
  },
  methods: {
    login() {
      const username = this.username;
      const password = this.password;
      const sucursal = this.modelSucursal.nombre.toLowerCase();
      this.loading = true;
      this.$store
        .dispatch("login", { username, password, sucursal })
        .then(() => {
          this.set();
          if (this.userLog.estado === "inactivo") {
            this.remove();
            this.$router.push("/auth/login");
            this.loading = false;
            this.serverError = "No puede ingresar al sistema";
          } else {
            this.launchEpicmaxToast();
            this.serverError = "";
            this.success = "Ingresando....";
            this.loading = false;
            this.$router.push("admin/dashboard");
            this.success = "";
          }
        })
        .catch((error) => {
          this.serverError = "";
          this.loading = false;
          console.log(error);
          this.remove();
          this.serverError = "Email y/o contraseña incorrecto";
          this.password = "";
          document.getElementById("password").focus();
        });
    },
    set() {
      localStorage.setItem("sucursal", this.modelSucursal.nombre);
      localStorage.setItem("sucursal_id", this.modelSucursal.id);
      const dataUserFromLocalStorage = JSON.parse(window.localStorage.user);
      axios
        .post("http://localhost:3010/login", {
          username: window.localStorage.nombre,
          id: dataUserFromLocalStorage.id,
          token: window.localStorage.token,
          refresh_token: window.localStorage.refreshToken,
        })
        .then(console.log)
        .catch(console.log);
    },
    remove() {
      localStorage.removeItem("sucursal");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("sucursal_id");
      localStorage.removeItem("usuario_id");
      localStorage.removeItem("nombre");
      localStorage.removeItem("username");
      localStorage.removeItem("pass");
    },
    launchEpicmaxToast() {
      this.showToast(
        `Bienvenido ${window.localStorage.nombre} a Repuestos Miranda SpA`,
        {
          icon: "fa-car",
          position: "bottom-right",
          duration: 2500,
        }
      );
    },
  },
  computed: {
    sucursales() {
      console.log("URL_SERVER", URL_SERVER);
      console.log("URL_SUCURSAL", URL_SUCURSAL);
      console.log(
        "this.$store.getters.sucursales",
        this.$store.getters.sucursales
      );
      return this.$store.getters.sucursales;
    },
  },
  created() {
    this.$store.dispatch("loadSucursal");
  },
  filters: {
    upperCase(texto) {
      return texto.toUpperCase();
    },
  },
};
</script>

<style lang="scss">
.login {
  @include media-breakpoint-down(md) {
    width: 100%;
    padding-right: 2rem;
    padding-left: 2rem;
    .down-container {
      display: none;
    }
  }

  h2 {
    text-align: center;
    margin: 0;
    font-weight: bold;
  }

  width: 21.375rem;

  .down-container {
    margin-top: 3.125rem;
  }

  button {
    margin-left: 55px;
  }

  .spinner {
    size: 50px;
    margin-left: 37%;
    margin-bottom: 5%;
  }

  select {
    cursor: pointer;
  }

  .pag {
    color: $color-corporativo;
  }
}
</style>
